import { ApiKeysService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { apiKeysKeys } from './apiKeysKeys';
import type { TCall } from '../types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof apiKeysKeys.list>>;

export const createFetchOrganizationApiKeysQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(ApiKeysService.findAll({ organizationId }), signal));
